import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from '@ow/ow-components/lib/components/Modal';
import SearchBar from '../SearchBar';
import theme from '@ow/ow-components/lib/theme';
import UseCurrentLocationButton from '../UseCurrentLocationButton';
import { Flex, Box } from 'rebass';
import Script from 'react-load-script';
import Spinner from '@ow/ow-components/lib/components/Spinner';
import { GOOGLE_MAP_URL } from '../../../constants/googleMapUrl';
import { LayerManager } from '../../../utils/PageScrollUtils';
import { FIND_STORE_BORDER_HEIGHT } from '../../../constants/style';
import { dispatchEvent } from '@ow/ow-analytics';

const ModalHeading = styled.h2`
  font-size: ${theme.fontSizes[4]}px;
  text-align: center;
  margin-bottom: ${theme.space.standard};
`;

const ResponsiveWrapper = styled(Flex)`
  align-items: center;
  flex-direction: column;
  @media ${theme.mediaSize.largeMin} {
    align-items: flex-start;
    flex-direction: row;
  }

  > div:first-child {
    @media ${theme.mediaSize.largeMin} {
      width: auto; /* Fix for IE 11 RT-4571  */
    }
  }
`;

const StyledBox = styled(Box)`
  text-align: center;
`;

const layer = LayerManager.getLayerByName('location');

class EnterLocationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { googleMapJSLoaded: false };
  }

  // Google Maps loading
  handleGoogleMapJSLoad = loaded => {
    this.setState({
      googleMapJSLoaded: loaded
    });
  };

  componentDidMount() {
    LayerManager.addLayer(layer);
    dispatchEvent('enter-location-modal-open');
  }

  componentWillUnmount() {
    LayerManager.removeLayer(layer);
  }

  render() {
    const { onSelectLocation, onGettingUserCoordinates, closeModal, setStoreNotFound } = this.props;
    return (
      <>
        <Script
          url={GOOGLE_MAP_URL}
          onError={() => this.handleGoogleMapJSLoad(false)}
          onLoad={() => this.handleGoogleMapJSLoad(true)}
        />
        {this.state.googleMapJSLoaded ? (
          <Modal
            contentStyle={{ maxWidth: '700px' }}
            isOpen={true}
            onRequestClose={() => {
              closeModal();
              setStoreNotFound(false);
            }}
          >
            <Flex
              data-ref="enter-location-modal"
              flexDirection={'column'}
              p={theme.space.standard}
              alignItems="stretch"
              flex="1"
            >
              <ModalHeading>Enter location</ModalHeading>
              <StyledBox mx="auto" mb={theme.space.half}>
                Please enter your suburb to see availability information and estimated delivery
                dates.
              </StyledBox>
              <ResponsiveWrapper alignItems="flex-start">
                <SearchBar
                  onSearch={onSelectLocation}
                  dropDownWidth={'50%'}
                  borderHeight={FIND_STORE_BORDER_HEIGHT}
                />
                <UseCurrentLocationButton onSuccess={onGettingUserCoordinates} />
              </ResponsiveWrapper>
            </Flex>
          </Modal>
        ) : (
          <Spinner />
        )}
      </>
    );
  }
}

EnterLocationModal.propTypes = {
  closeModal: PropTypes.func,
  onGettingUserCoordinates: PropTypes.func.isRequired,
  onSelectLocation: PropTypes.func.isRequired,
  setStoreNotFound: PropTypes.func.isRequired
};

EnterLocationModal.defaultProps = {
  autocompleteSuburbs: []
};

export default EnterLocationModal;
